import AppStoreModule from '@app/store/modules/AppStoreModule';
import { getModule as getStoreModule } from 'vuex-module-decorators';

export default class OfflineError extends Error {
	public constructor(message?: string) {
		super(message);
		this.name = 'OfflineError';
	}
}

export function isNetworkOrOfflineErrorAndAppIsOffline(error: Error | OfflineError | unknown): boolean {
	const appStore: AppStoreModule = getStoreModule(AppStoreModule);
	return (error instanceof OfflineError || (error as any).message === 'Network Error') && !appStore.isOnline;
}

export function throwIfNotOfflineError(error: Error | unknown): void {
	// ignore offline errors, throw everything else
	if (error instanceof OfflineError) return;

	throw error;
}
